import type { ManifestConditionalPackage, RawManifest, ResolvedManifest } from '@pp/toolkit';

declare global {
  interface Window {
    appManifest?: ResolvedManifest;
  }
}

export class AppManifestBase {
  constructor(private manifest?: ResolvedManifest) {}

  getFlag(key: string): boolean | string {
    if (!this.manifest) return false;
    try {
      return this.manifest.flags?.[key] ?? false;
    } catch (_error) {
      return false;
    }
  }

  getBooleanFlag(key: string): boolean {
    return Boolean(this.getFlag(key));
  }

  getPackage(key: string): ManifestConditionalPackage | undefined {
    if (!this.manifest) return;
    try {
      return this.manifest?.packages?.[key] ?? undefined;
    } catch (_error) {
      // do nothing
    }
  }

  getValue(key: string): unknown {
    if (!this.manifest) return undefined;
    try {
      return this.manifest?.values?.[key]?.value ?? undefined;
    } catch (_error) {
      // do nothing
    }
  }

  getValueAsNumber(key: string): number | undefined {
    const value = this.getValue(key);
    const number = Number(value);
    if (isNaN(number)) return;
    return number;
  }

  getRawManifest(): RawManifest | undefined {
    return this.manifest?.raw;
  }

  setManifest(manifest?: ResolvedManifest): void {
    this.manifest = manifest;
  }
}

window.addEventListener('manifest-loaded', () => {
  AppManifest.setManifest(window.appManifest ?? undefined);
});

export const AppManifest = new AppManifestBase(window.appManifest ?? undefined);
